import { FormTimeInputComponent } from 'src/features/generalForms/builder/types/DateInput';
import { millsToTimeString } from 'src/helpers/date-helpers';
import { AnswerPreviewRow } from '../previewRow/answerPreviewRow';
import { useAnswerRowConditional } from 'src/features/generalForms/answerPreview/hooks/useAnswerRowConditional';
import { useAnswerValue } from 'src/features/generalForms/answerPreview/hooks/useAnswerValue';
import { RPDF } from 'src/features/report/react-pdf';

export const FormTimeInput: FormTimeInputComponent = (props) => {
  const value = useAnswerValue(props.dataKey!);
  const { visible } = useAnswerRowConditional();
  if (!visible) {
    return <RPDF.View />;
  }

  return (
    <AnswerPreviewRow<number>
      value={value !== undefined && value !== null ? Number(value) : undefined}
      renderValue={(val) => millsToTimeString(val)}
      {...props}
    />
  );
};
